import { render, staticRenderFns } from "./TaskChangeEmployees.vue?vue&type=template&id=8ef3c09a"
import script from "./TaskChangeEmployees.vue?vue&type=script&lang=ts"
export * from "./TaskChangeEmployees.vue?vue&type=script&lang=ts"
import style0 from "./TaskChangeEmployees.vue?vue&type=style&index=0&id=8ef3c09a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports